import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronDown,
  faChevronUp,
  faUser,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons'
import './DropdownMenu.scss'
import TsxUtils from '../../../../utils/tsx'
import { useLocation } from 'react-router-dom'
import { CypressSelectable } from '../../../../types'

interface DropdownMenuProps extends CypressSelectable {
  headerTitle: string
  icon?: IconDefinition
  subPages: string[]
  children: React.ReactNode
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  headerTitle,
  icon = faUser,
  subPages,
  children,
  dataCy,
}) => {
  const [open, setOpen] = useState<boolean>(false)
  const location = useLocation()
  useEffect(() => {
    const subPageMatch = subPages.some(page => {
      return location.pathname === page
    })
    setOpen(subPageMatch)
  }, [location])
  return (
    <div
      className={'DropdownMenu'}
      data-cy={dataCy}
    >
      <div
        className={'DropdownMenu__header-container'}
        onClick={() => setOpen(!open)}
      >
        <div className='DropdownMenu__header-container__marker' />
        <div className='DropdownMenu__header'>
          <FontAwesomeIcon
            icon={icon}
            className='NavbarItem__icon'
          />
          <div className='NavbarItem__text'>{headerTitle}</div>
          <FontAwesomeIcon
            icon={open ? faChevronUp : faChevronDown}
            className='TopBarUser__arrow'
          />
        </div>
      </div>
      <div
        className={
          'DropdownMenu__container' + TsxUtils.extraStyle(open, 'DropdownMenu__container--active')
        }
      >
        {children}
      </div>
    </div>
  )
}

export default DropdownMenu
